module.exports = __webpack_public_path__ + "animoji1.362deb6293.png";